import React from 'react';
import { Controller } from 'react-hook-form';
import { Box, Typography, IconButton } from '@mui/material';
import { amber } from '@mui/material/colors';


export interface MeetingOutcomeScoreFieldProps {
    name?: string;
    label?: string;
    disabled?: boolean;
}

export const MeetingOutcomeScoreField: React.FC<MeetingOutcomeScoreFieldProps> = ({
  name = 'score',
  label = 'How well did this meeting achieve its desired outcome?',
  disabled,

}) => {
  const numbers = React.useMemo(() => Array.from({ length: 10 }, (_, i) => i + 1), []);

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="h6" fontWeight={700}>
        {label}
      </Typography>
      <Controller
        name={name}
        defaultValue={null}
        render={({ field: { value, onChange } }) => (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: { xs: 1 },
              width: '100%',
            }}
          >
            {numbers.map((number) => {
              const isSelected = value === number;
              return (
                <IconButton
                  key={number}
                  aria-label={`Rate ${number}`}
                  aria-pressed={isSelected}
                  onClick={() => onChange(number)}
                  disabled={disabled}
                  disableRipple
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '50%',
                    fontSize: 18,
                    fontWeight: 700,
                    color: isSelected ? '#fff' : 'text.primary',
                    backgroundColor: isSelected ? amber[500] : 'transparent',
                    '&:hover': {
                      backgroundColor: isSelected ? amber[600] : 'transparent',
                    },
                  }}
                >
                  {number}
                </IconButton>
              );
            })}
          </Box>
        )}
      />
    </Box>
  );
};